import { INotationWidgetRole } from '../Interfaces/INotationWidgetRole';

export function GetRoles() {
  return [
    {
      name: 'Anyone',
      helper:
        'Anyone is defined as any campus user who does not have a role in Beacon. Generally students are in this category unless they are a peer advisor',
      value: 0b0001,
    },
    {
      name: 'Peer-Advisor',
      helper: '',
      value: 0b0010,
    },
    { name: 'Advisor', helper: '', value: 0b0100 },
    {
      name: 'Generalist+',
      helper:
        'Generalist+ includes those with the role of Generalists, Executives, and Administrators',
      value: 0b1000,
    },
  ] as INotationWidgetRole[];
}
